import { Storage } from "../../services/storage/storage";

function toAvatar(response) {
  let avatar = {};
  avatar.thumb = response.thumbnailUrl;
  avatar.url = response.imageUrl ?? "";
  avatar.mimetype = response.mimetype ?? "";
  return avatar;
}

function toSessionUser(sessionUser) {
  let user = this.toUser(sessionUser);
  updateSessionUserInfo(user);
  return user;
}

function updateSessionUserInfo(user) {
  let info = Storage.getLoggedInUser() ?? {};
  info.user = user;
  Storage.setLoggedInUser(info);
}

function toPageInfo(pageInfo) {
  let isNextPageExist =
    pageInfo.currentPage < pageInfo.totalPages ? true : false;
  return {
    isNextPageExist: isNextPageExist,
    currentPage: pageInfo.currentPage,
    totalPages: pageInfo.totalPages,
    totalItems: pageInfo.totalItems,
  };
}


export { toAvatar, toSessionUser, toPageInfo };
